export const getFileFromNwCDN = (filePath: string) =>
  `https://cdns3.nerdwallet.com/nerdwallet-advisors/wealth-partners/${filePath}`
